const RadiusValues = Object.freeze({
    circle: '50%',
    r0: 0,
    r2: 2,
    r4: 4,
    r8: 8,
    r12: 12,
    r16: 16,
    r20: 20,
    r22: 22,
    r24: 24,
    r32: 32,
});

export { RadiusValues };
